import ConfigurationService from "../../ConfigurationService";
import store from '../../../store';

export default class ProgressBarService {
  static getStep(currentView) {
    if (store === undefined) return 1;

    const path = ConfigurationService.getViewsPath();

    const currentViewObject = path.find(step => step[currentView] !== undefined);

    return ConfigurationService.getViewStep(currentViewObject);
  }

  static getStepsCount() {
    const path = ConfigurationService.getViewsPath();

    const viewObject = path[path.length - 1];

    return ConfigurationService.getViewStep(viewObject);
  }
};
